export default __webpack_public_path__ + "static/media/spotTop.50b42bf5.svg";